import { createFeatureSelector, createSelector } from '@ngrx/store';

import { settingFeatureKey, State } from '../reducers/setting.reducer';

export const selectSettingFeature = createFeatureSelector<State>(settingFeatureKey);

export const selectReferralCode = createSelector(selectSettingFeature, (state: State) => state.referralCode);

export const selectApplicationKey = createSelector(selectSettingFeature, (state: State) => state.applicationKey);

export const selectParseType = createSelector(selectSettingFeature, (state: State) => state.parseType);

export const selectHasValidReferralCode = createSelector(
  selectSettingFeature,
  (state: State) => state.hasValidReferralCode
);

export const selectReferralFormValidationErrors = createSelector(
  selectSettingFeature,
  (state: State) => state.referralCodeFormValidationErrors
);

export const selectAlternateAppIconUsed = createSelector(
  selectSettingFeature,
  (state: State) => state.alternateAppIconUsed
);

export const selectAvailableStates = createSelector(selectSettingFeature, (state: State) => state.availableStates);

export const selectSelectedState = createSelector(selectSettingFeature, (state: State) => state.selectedState);

export const selectAvailableCounties = createSelector(selectSettingFeature, (state: State) => state.availableCounties);

export const selectSelectedCounty = createSelector(selectSettingFeature, (state: State) => state.selectedCounty);

export const selectIsDebugModeEnabled = createSelector(
  selectSettingFeature,
  (state: State) => state.isDebugModeEnabled
);

export const selectEnableTooltips = createSelector(selectSettingFeature, (state: State) => state.enableTooltips);
